import React, { useEffect, useState } from "react";
import { useReduxState } from "hooks/useReduxState";
import { useRequestMutation } from "hooks/useRequest";
import Viewer from "../viewer";

interface Props {
  researchKeyPdf: string;
}

const AiResearchViewer: React.FunctionComponent<Props> = ({
  researchKeyPdf
}) => {
  const [url, setUrl] = useState<string>();
  const { trialFlg } = useReduxState(state => state.auth.saved.user);
  const visiblePrintButton = !trialFlg;
  const visibleSaveButton = !trialFlg;

  const { trigger: fetchSourcePdf } = useRequestMutation<string>(
    "/sse/query/rag/source-pdf",
    "GET"
  );

  useEffect(() => {
    fetchSourcePdf({ keyPdf: researchKeyPdf })
      .then(setUrl)
      .catch(e => {
        if (e.message === "UNAUTHORIZED") {
          location.href = "/login";
        }
        setUrl(undefined);
      });
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [researchKeyPdf]);

  if (!url) return null;

  return (
    <Viewer
      src={url}
      visiblePrintButton={visiblePrintButton}
      visibleSaveButton={visibleSaveButton}
    />
  );
};

export default AiResearchViewer;
